export const AUTH_REQUEST = 'AUTH_REQUEST';
export const SET_TOKENS = 'SET_TOKENS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';

export const GET_POSITION_DATA = 'GET_POSITION_DATA';
export const SET_POSITION_DATA = 'SET_POSITION_DATA';
export const CLEAR_POSITION_LOADER_TIMEOUT = 'CLEAR_POSITION_LOADER_TIMEOUT';

export const SET_MAP_OBJECT = 'SET_MAP_OBJECT';
export const ADJUST_MAP_SIZE = 'ADJUST_MAP_SIZE';

export const RESET_STORE = 'RESET_STORE';